export default [
  {
    'label': 'Alajärvi',
    'parent': 'Etelä-Pohjanmaa',
  },
  {
    'label': 'Alavieska',
    'parent': 'Pohjois-Pohjanmaa',
  },
  {
    'label': 'Alavus',
    'parent': 'Etelä-Pohjanmaa',
  },
  {
    'label': 'Asikkala',
    'parent': 'Päijät-Häme',
  },
  {
    'label': 'Askola',
    'parent': 'Uusimaa',
  },
  {
    'label': 'Aura',
    'parent': 'Varsinais-Suomi',
  },
  {
    'label': 'Akaa',
    'parent': 'Pirkanmaa',
  },
  {
    'label': 'Brändö',
    'parent': 'Ahvenanmaa',
  },
  {
    'label': 'Eckerö',
    'parent': 'Ahvenanmaa',
  },
  {
    'label': 'Enonkoski',
    'parent': 'Etelä-Savo',
  },
  {
    'label': 'Enontekiö',
    'parent': 'Lappi',
  },
  {
    'label': 'Espoo',
    'parent': 'Uusimaa',
  },
  {
    'label': 'Eura',
    'parent': 'Satakunta',
  },
  {
    'label': 'Eurajoki',
    'parent': 'Satakunta',
  },
  {
    'label': 'Evijärvi',
    'parent': 'Etelä-Pohjanmaa',
  },
  {
    'label': 'Finström',
    'parent': 'Ahvenanmaa',
  },
  {
    'label': 'Forssa',
    'parent': 'Kanta-Häme',
  },
  {
    'label': 'Föglö',
    'parent': 'Ahvenanmaa',
  },
  {
    'label': 'Geta',
    'parent': 'Ahvenanmaa',
  },
  {
    'label': 'Haapajärvi',
    'parent': 'Pohjois-Pohjanmaa',
  },
  {
    'label': 'Haapavesi',
    'parent': 'Pohjois-Pohjanmaa',
  },
  {
    'label': 'Hailuoto',
    'parent': 'Pohjois-Pohjanmaa',
  },
  {
    'label': 'Halsua',
    'parent': 'Keski-Pohjanmaa',
  },
  {
    'label': 'Hamina',
    'parent': 'Kymenlaakso',
  },
  {
    'label': 'Hammarland',
    'parent': 'Ahvenanmaa',
  },
  {
    'label': 'Hankasalmi',
    'parent': 'Keski-Suomi',
  },
  {
    'label': 'Hanko',
    'parent': 'Uusimaa',
  },
  {
    'label': 'Harjavalta',
    'parent': 'Satakunta',
  },
  {
    'label': 'Hartola',
    'parent': 'Päijät-Häme',
  },
  {
    'label': 'Hattula',
    'parent': 'Kanta-Häme',
  },
  {
    'label': 'Hausjärvi',
    'parent': 'Kanta-Häme',
  },
  {
    'label': 'Heinävesi',
    'parent': 'Etelä-Savo',
  },
  {
    'label': 'Helsinki',
    'parent': 'Uusimaa',
  },
  {
    'label': 'Vantaa',
    'parent': 'Uusimaa',
  },
  {
    'label': 'Hirvensalmi',
    'parent': 'Etelä-Savo',
  },
  {
    'label': 'Hollola',
    'parent': 'Päijät-Häme',
  },
  {
    'label': 'Honkajoki',
    'parent': 'Satakunta',
  },
  {
    'label': 'Huittinen',
    'parent': 'Satakunta',
  },
  {
    'label': 'Humppila',
    'parent': 'Kanta-Häme',
  },
  {
    'label': 'Hyrynsalmi',
    'parent': 'Kainuu',
  },
  {
    'label': 'Hyvinkää',
    'parent': 'Uusimaa',
  },
  {
    'label': 'Hämeenkyrö',
    'parent': 'Pirkanmaa',
  },
  {
    'label': 'Hämeenlinna',
    'parent': 'Kanta-Häme',
  },
  {
    'label': 'Heinola',
    'parent': 'Päijät-Häme',
  },
  {
    'label': 'Ii',
    'parent': 'Pohjois-Pohjanmaa',
  },
  {
    'label': 'Iisalmi',
    'parent': 'Pohjois-Savo',
  },
  {
    'label': 'Iitti',
    'parent': 'Kymenlaakso',
  },
  {
    'label': 'Ikaalinen',
    'parent': 'Pirkanmaa',
  },
  {
    'label': 'Ilmajoki',
    'parent': 'Etelä-Pohjanmaa',
  },
  {
    'label': 'Ilomantsi',
    'parent': 'Pohjois-Karjala',
  },
  {
    'label': 'Inari',
    'parent': 'Lappi',
  },
  {
    'label': 'Inkoo',
    'parent': 'Uusimaa',
  },
  {
    'label': 'Isojoki',
    'parent': 'Etelä-Pohjanmaa',
  },
  {
    'label': 'Isokyrö',
    'parent': 'Pohjanmaa',
  },
  {
    'label': 'Imatra',
    'parent': 'Etelä-Karjala',
  },
  {
    'label': 'Janakkala',
    'parent': 'Kanta-Häme',
  },
  {
    'label': 'Joensuu',
    'parent': 'Pohjois-Karjala',
  },
  {
    'label': 'Jokioinen',
    'parent': 'Kanta-Häme',
  },
  {
    'label': 'Jomala',
    'parent': 'Ahvenanmaa',
  },
  {
    'label': 'Joroinen',
    'parent': 'Etelä-Savo',
  },
  {
    'label': 'Joutsa',
    'parent': 'Keski-Suomi',
  },
  {
    'label': 'Juuka',
    'parent': 'Pohjois-Karjala',
  },
  {
    'label': 'Juupajoki',
    'parent': 'Pirkanmaa',
  },
  {
    'label': 'Juva',
    'parent': 'Etelä-Savo',
  },
  {
    'label': 'Jyväskylä',
    'parent': 'Keski-Suomi',
  },
  {
    'label': 'Jämijärvi',
    'parent': 'Satakunta',
  },
  {
    'label': 'Jämsä',
    'parent': 'Keski-Suomi',
  },
  {
    'label': 'Järvenpää',
    'parent': 'Uusimaa',
  },
  {
    'label': 'Kaarina',
    'parent': 'Varsinais-Suomi',
  },
  {
    'label': 'Kaavi',
    'parent': 'Pohjois-Savo',
  },
  {
    'label': 'Kajaani',
    'parent': 'Kainuu',
  },
  {
    'label': 'Kalajoki',
    'parent': 'Pohjois-Pohjanmaa',
  },
  {
    'label': 'Kangasala',
    'parent': 'Pirkanmaa',
  },
  {
    'label': 'Kangasniemi',
    'parent': 'Etelä-Savo',
  },
  {
    'label': 'Kankaanpää',
    'parent': 'Satakunta',
  },
  {
    'label': 'Kannonkoski',
    'parent': 'Keski-Suomi',
  },
  {
    'label': 'Kannus',
    'parent': 'Keski-Pohjanmaa',
  },
  {
    'label': 'Karijoki',
    'parent': 'Etelä-Pohjanmaa',
  },
  {
    'label': 'Karkkila',
    'parent': 'Uusimaa',
  },
  {
    'label': 'Karstula',
    'parent': 'Keski-Suomi',
  },
  {
    'label': 'Karvia',
    'parent': 'Satakunta',
  },
  {
    'label': 'Kaskinen',
    'parent': 'Pohjanmaa',
  },
  {
    'label': 'Kauhajoki',
    'parent': 'Etelä-Pohjanmaa',
  },
  {
    'label': 'Kauhava',
    'parent': 'Etelä-Pohjanmaa',
  },
  {
    'label': 'Kauniainen',
    'parent': 'Uusimaa',
  },
  {
    'label': 'Kaustinen',
    'parent': 'Keski-Pohjanmaa',
  },
  {
    'label': 'Keitele',
    'parent': 'Pohjois-Savo',
  },
  {
    'label': 'Kemi',
    'parent': 'Lappi',
  },
  {
    'label': 'Keminmaa',
    'parent': 'Lappi',
  },
  {
    'label': 'Kempele',
    'parent': 'Pohjois-Pohjanmaa',
  },
  {
    'label': 'Kerava',
    'parent': 'Uusimaa',
  },
  {
    'label': 'Keuruu',
    'parent': 'Keski-Suomi',
  },
  {
    'label': 'Kihniö',
    'parent': 'Pirkanmaa',
  },
  {
    'label': 'Kinnula',
    'parent': 'Keski-Suomi',
  },
  {
    'label': 'Kirkkonummi',
    'parent': 'Uusimaa',
  },
  {
    'label': 'Kitee',
    'parent': 'Pohjois-Karjala',
  },
  {
    'label': 'Kittilä',
    'parent': 'Lappi',
  },
  {
    'label': 'Kiuruvesi',
    'parent': 'Pohjois-Savo',
  },
  {
    'label': 'Kivijärvi',
    'parent': 'Keski-Suomi',
  },
  {
    'label': 'Kokemäki',
    'parent': 'Satakunta',
  },
  {
    'label': 'Kokkola',
    'parent': 'Keski-Pohjanmaa',
  },
  {
    'label': 'Kolari',
    'parent': 'Lappi',
  },
  {
    'label': 'Konnevesi',
    'parent': 'Keski-Suomi',
  },
  {
    'label': 'Kontiolahti',
    'parent': 'Pohjois-Karjala',
  },
  {
    'label': 'Korsnäs',
    'parent': 'Pohjanmaa',
  },
  {
    'label': 'Koski Tl',
    'parent': 'Varsinais-Suomi',
  },
  {
    'label': 'Kotka',
    'parent': 'Kymenlaakso',
  },
  {
    'label': 'Kouvola',
    'parent': 'Kymenlaakso',
  },
  {
    'label': 'Kristiinankaupunki',
    'parent': 'Pohjanmaa',
  },
  {
    'label': 'Kruunupyy',
    'parent': 'Pohjanmaa',
  },
  {
    'label': 'Kuhmo',
    'parent': 'Kainuu',
  },
  {
    'label': 'Kuhmoinen',
    'parent': 'Keski-Suomi',
  },
  {
    'label': 'Kumlinge',
    'parent': 'Ahvenanmaa',
  },
  {
    'label': 'Kuopio',
    'parent': 'Pohjois-Savo',
  },
  {
    'label': 'Kuortane',
    'parent': 'Etelä-Pohjanmaa',
  },
  {
    'label': 'Kurikka',
    'parent': 'Etelä-Pohjanmaa',
  },
  {
    'label': 'Kustavi',
    'parent': 'Varsinais-Suomi',
  },
  {
    'label': 'Kuusamo',
    'parent': 'Pohjois-Pohjanmaa',
  },
  {
    'label': 'Outokumpu',
    'parent': 'Pohjois-Karjala',
  },
  {
    'label': 'Kyyjärvi',
    'parent': 'Keski-Suomi',
  },
  {
    'label': 'Kärkölä',
    'parent': 'Päijät-Häme',
  },
  {
    'label': 'Kärsämäki',
    'parent': 'Pohjois-Pohjanmaa',
  },
  {
    'label': 'Kökar',
    'parent': 'Ahvenanmaa',
  },
  {
    'label': 'Kemijärvi',
    'parent': 'Lappi',
  },
  {
    'label': 'Kemiönsaari',
    'parent': 'Varsinais-Suomi',
  },
  {
    'label': 'Lahti',
    'parent': 'Päijät-Häme',
  },
  {
    'label': 'Laihia',
    'parent': 'Pohjanmaa',
  },
  {
    'label': 'Laitila',
    'parent': 'Varsinais-Suomi',
  },
  {
    'label': 'Lapinlahti',
    'parent': 'Pohjois-Savo',
  },
  {
    'label': 'Lappajärvi',
    'parent': 'Etelä-Pohjanmaa',
  },
  {
    'label': 'Lappeenranta',
    'parent': 'Etelä-Karjala',
  },
  {
    'label': 'Lapinjärvi',
    'parent': 'Uusimaa',
  },
  {
    'label': 'Lapua',
    'parent': 'Etelä-Pohjanmaa',
  },
  {
    'label': 'Laukaa',
    'parent': 'Keski-Suomi',
  },
  {
    'label': 'Lemi',
    'parent': 'Etelä-Karjala',
  },
  {
    'label': 'Lemland',
    'parent': 'Ahvenanmaa',
  },
  {
    'label': 'Lempäälä',
    'parent': 'Pirkanmaa',
  },
  {
    'label': 'Leppävirta',
    'parent': 'Pohjois-Savo',
  },
  {
    'label': 'Lestijärvi',
    'parent': 'Keski-Pohjanmaa',
  },
  {
    'label': 'Lieksa',
    'parent': 'Pohjois-Karjala',
  },
  {
    'label': 'Lieto',
    'parent': 'Varsinais-Suomi',
  },
  {
    'label': 'Liminka',
    'parent': 'Pohjois-Pohjanmaa',
  },
  {
    'label': 'Liperi',
    'parent': 'Pohjois-Karjala',
  },
  {
    'label': 'Loimaa',
    'parent': 'Varsinais-Suomi',
  },
  {
    'label': 'Loppi',
    'parent': 'Kanta-Häme',
  },
  {
    'label': 'Loviisa',
    'parent': 'Uusimaa',
  },
  {
    'label': 'Luhanka',
    'parent': 'Keski-Suomi',
  },
  {
    'label': 'Lumijoki',
    'parent': 'Pohjois-Pohjanmaa',
  },
  {
    'label': 'Lumparland',
    'parent': 'Ahvenanmaa',
  },
  {
    'label': 'Luoto',
    'parent': 'Pohjanmaa',
  },
  {
    'label': 'Luumäki',
    'parent': 'Etelä-Karjala',
  },
  {
    'label': 'Lohja',
    'parent': 'Uusimaa',
  },
  {
    'label': 'Parainen',
    'parent': 'Varsinais-Suomi',
  },
  {
    'label': 'Maalahti',
    'parent': 'Pohjanmaa',
  },
  {
    'label': 'Maarianhamina',
    'parent': 'Ahvenanmaa',
  },
  {
    'label': 'Marttila',
    'parent': 'Varsinais-Suomi',
  },
  {
    'label': 'Masku',
    'parent': 'Varsinais-Suomi',
  },
  {
    'label': 'Merijärvi',
    'parent': 'Pohjois-Pohjanmaa',
  },
  {
    'label': 'Merikarvia',
    'parent': 'Satakunta',
  },
  {
    'label': 'Miehikkälä',
    'parent': 'Kymenlaakso',
  },
  {
    'label': 'Mikkeli',
    'parent': 'Etelä-Savo',
  },
  {
    'label': 'Muhos',
    'parent': 'Pohjois-Pohjanmaa',
  },
  {
    'label': 'Multia',
    'parent': 'Keski-Suomi',
  },
  {
    'label': 'Muonio',
    'parent': 'Lappi',
  },
  {
    'label': 'Mustasaari',
    'parent': 'Pohjanmaa',
  },
  {
    'label': 'Muurame',
    'parent': 'Keski-Suomi',
  },
  {
    'label': 'Mynämäki',
    'parent': 'Varsinais-Suomi',
  },
  {
    'label': 'Myrskylä',
    'parent': 'Uusimaa',
  },
  {
    'label': 'Mäntsälä',
    'parent': 'Uusimaa',
  },
  {
    'label': 'Mäntyharju',
    'parent': 'Etelä-Savo',
  },
  {
    'label': 'Mänttä-Vilppula',
    'parent': 'Pirkanmaa',
  },
  {
    'label': 'Naantali',
    'parent': 'Varsinais-Suomi',
  },
  {
    'label': 'Nakkila',
    'parent': 'Satakunta',
  },
  {
    'label': 'Nivala',
    'parent': 'Pohjois-Pohjanmaa',
  },
  {
    'label': 'Nokia',
    'parent': 'Pirkanmaa',
  },
  {
    'label': 'Nousiainen',
    'parent': 'Varsinais-Suomi',
  },
  {
    'label': 'Nurmes',
    'parent': 'Pohjois-Karjala',
  },
  {
    'label': 'Nurmijärvi',
    'parent': 'Uusimaa',
  },
  {
    'label': 'Närpiö',
    'parent': 'Pohjanmaa',
  },
  {
    'label': 'Orimattila',
    'parent': 'Päijät-Häme',
  },
  {
    'label': 'Oripää',
    'parent': 'Varsinais-Suomi',
  },
  {
    'label': 'Orivesi',
    'parent': 'Pirkanmaa',
  },
  {
    'label': 'Oulainen',
    'parent': 'Pohjois-Pohjanmaa',
  },
  {
    'label': 'Oulu',
    'parent': 'Pohjois-Pohjanmaa',
  },
  {
    'label': 'Padasjoki',
    'parent': 'Päijät-Häme',
  },
  {
    'label': 'Paimio',
    'parent': 'Varsinais-Suomi',
  },
  {
    'label': 'Paltamo',
    'parent': 'Kainuu',
  },
  {
    'label': 'Parikkala',
    'parent': 'Etelä-Karjala',
  },
  {
    'label': 'Parkano',
    'parent': 'Pirkanmaa',
  },
  {
    'label': 'Pelkosenniemi',
    'parent': 'Lappi',
  },
  {
    'label': 'Perho',
    'parent': 'Keski-Pohjanmaa',
  },
  {
    'label': 'Pertunmaa',
    'parent': 'Etelä-Savo',
  },
  {
    'label': 'Petäjävesi',
    'parent': 'Keski-Suomi',
  },
  {
    'label': 'Pieksämäki',
    'parent': 'Etelä-Savo',
  },
  {
    'label': 'Pielavesi',
    'parent': 'Pohjois-Savo',
  },
  {
    'label': 'Pietarsaari',
    'parent': 'Pohjanmaa',
  },
  {
    'label': 'Pedersören kunta',
    'parent': 'Pohjanmaa',
  },
  {
    'label': 'Pihtipudas',
    'parent': 'Keski-Suomi',
  },
  {
    'label': 'Pirkkala',
    'parent': 'Pirkanmaa',
  },
  {
    'label': 'Polvijärvi',
    'parent': 'Pohjois-Karjala',
  },
  {
    'label': 'Pomarkku',
    'parent': 'Satakunta',
  },
  {
    'label': 'Pori',
    'parent': 'Satakunta',
  },
  {
    'label': 'Pornainen',
    'parent': 'Uusimaa',
  },
  {
    'label': 'Posio',
    'parent': 'Lappi',
  },
  {
    'label': 'Pudasjärvi',
    'parent': 'Pohjois-Pohjanmaa',
  },
  {
    'label': 'Pukkila',
    'parent': 'Uusimaa',
  },
  {
    'label': 'Punkalaidun',
    'parent': 'Pirkanmaa',
  },
  {
    'label': 'Puolanka',
    'parent': 'Kainuu',
  },
  {
    'label': 'Puumala',
    'parent': 'Etelä-Savo',
  },
  {
    'label': 'Pyhtää',
    'parent': 'Kymenlaakso',
  },
  {
    'label': 'Pyhäjoki',
    'parent': 'Pohjois-Pohjanmaa',
  },
  {
    'label': 'Pyhäjärvi',
    'parent': 'Pohjois-Pohjanmaa',
  },
  {
    'label': 'Pyhäntä',
    'parent': 'Pohjois-Pohjanmaa',
  },
  {
    'label': 'Pyhäranta',
    'parent': 'Varsinais-Suomi',
  },
  {
    'label': 'Pälkäne',
    'parent': 'Pirkanmaa',
  },
  {
    'label': 'Pöytyä',
    'parent': 'Varsinais-Suomi',
  },
  {
    'label': 'Porvoo',
    'parent': 'Uusimaa',
  },
  {
    'label': 'Raahe',
    'parent': 'Pohjois-Pohjanmaa',
  },
  {
    'label': 'Raisio',
    'parent': 'Varsinais-Suomi',
  },
  {
    'label': 'Rantasalmi',
    'parent': 'Etelä-Savo',
  },
  {
    'label': 'Ranua',
    'parent': 'Lappi',
  },
  {
    'label': 'Rauma',
    'parent': 'Satakunta',
  },
  {
    'label': 'Rautalampi',
    'parent': 'Pohjois-Savo',
  },
  {
    'label': 'Rautavaara',
    'parent': 'Pohjois-Savo',
  },
  {
    'label': 'Rautjärvi',
    'parent': 'Etelä-Karjala',
  },
  {
    'label': 'Reisjärvi',
    'parent': 'Pohjois-Pohjanmaa',
  },
  {
    'label': 'Riihimäki',
    'parent': 'Kanta-Häme',
  },
  {
    'label': 'Ristijärvi',
    'parent': 'Kainuu',
  },
  {
    'label': 'Rovaniemi',
    'parent': 'Lappi',
  },
  {
    'label': 'Ruokolahti',
    'parent': 'Etelä-Karjala',
  },
  {
    'label': 'Ruovesi',
    'parent': 'Pirkanmaa',
  },
  {
    'label': 'Rusko',
    'parent': 'Varsinais-Suomi',
  },
  {
    'label': 'Rääkkylä',
    'parent': 'Pohjois-Karjala',
  },
  {
    'label': 'Raasepori',
    'parent': 'Uusimaa',
  },
  {
    'label': 'Saarijärvi',
    'parent': 'Keski-Suomi',
  },
  {
    'label': 'Salla',
    'parent': 'Lappi',
  },
  {
    'label': 'Salo',
    'parent': 'Varsinais-Suomi',
  },
  {
    'label': 'Saltvik',
    'parent': 'Ahvenanmaa',
  },
  {
    'label': 'Sauvo',
    'parent': 'Varsinais-Suomi',
  },
  {
    'label': 'Savitaipale',
    'parent': 'Etelä-Karjala',
  },
  {
    'label': 'Savonlinna',
    'parent': 'Etelä-Savo',
  },
  {
    'label': 'Savukoski',
    'parent': 'Lappi',
  },
  {
    'label': 'Seinäjoki',
    'parent': 'Etelä-Pohjanmaa',
  },
  {
    'label': 'Sievi',
    'parent': 'Pohjois-Pohjanmaa',
  },
  {
    'label': 'Siikainen',
    'parent': 'Satakunta',
  },
  {
    'label': 'Siikajoki',
    'parent': 'Pohjois-Pohjanmaa',
  },
  {
    'label': 'Siilinjärvi',
    'parent': 'Pohjois-Savo',
  },
  {
    'label': 'Simo',
    'parent': 'Lappi',
  },
  {
    'label': 'Sipoo',
    'parent': 'Uusimaa',
  },
  {
    'label': 'Siuntio',
    'parent': 'Uusimaa',
  },
  {
    'label': 'Sodankylä',
    'parent': 'Lappi',
  },
  {
    'label': 'Soini',
    'parent': 'Etelä-Pohjanmaa',
  },
  {
    'label': 'Somero',
    'parent': 'Varsinais-Suomi',
  },
  {
    'label': 'Sonkajärvi',
    'parent': 'Pohjois-Savo',
  },
  {
    'label': 'Sotkamo',
    'parent': 'Kainuu',
  },
  {
    'label': 'Sottunga',
    'parent': 'Ahvenanmaa',
  },
  {
    'label': 'Sulkava',
    'parent': 'Etelä-Savo',
  },
  {
    'label': 'Sund',
    'parent': 'Ahvenanmaa',
  },
  {
    'label': 'Suomussalmi',
    'parent': 'Kainuu',
  },
  {
    'label': 'Suonenjoki',
    'parent': 'Pohjois-Savo',
  },
  {
    'label': 'Sysmä',
    'parent': 'Päijät-Häme',
  },
  {
    'label': 'Säkylä',
    'parent': 'Satakunta',
  },
  {
    'label': 'Vaala',
    'parent': 'Pohjois-Pohjanmaa',
  },
  {
    'label': 'Sastamala',
    'parent': 'Pirkanmaa',
  },
  {
    'label': 'Siikalatva',
    'parent': 'Pohjois-Pohjanmaa',
  },
  {
    'label': 'Taipalsaari',
    'parent': 'Etelä-Karjala',
  },
  {
    'label': 'Taivalkoski',
    'parent': 'Pohjois-Pohjanmaa',
  },
  {
    'label': 'Taivassalo',
    'parent': 'Varsinais-Suomi',
  },
  {
    'label': 'Tammela',
    'parent': 'Kanta-Häme',
  },
  {
    'label': 'Tampere',
    'parent': 'Pirkanmaa',
  },
  {
    'label': 'Tervo',
    'parent': 'Pohjois-Savo',
  },
  {
    'label': 'Tervola',
    'parent': 'Lappi',
  },
  {
    'label': 'Teuva',
    'parent': 'Etelä-Pohjanmaa',
  },
  {
    'label': 'Tohmajärvi',
    'parent': 'Pohjois-Karjala',
  },
  {
    'label': 'Toholampi',
    'parent': 'Keski-Pohjanmaa',
  },
  {
    'label': 'Toivakka',
    'parent': 'Keski-Suomi',
  },
  {
    'label': 'Tornio',
    'parent': 'Lappi',
  },
  {
    'label': 'Turku',
    'parent': 'Varsinais-Suomi',
  },
  {
    'label': 'Pello',
    'parent': 'Lappi',
  },
  {
    'label': 'Tuusniemi',
    'parent': 'Pohjois-Savo',
  },
  {
    'label': 'Tuusula',
    'parent': 'Uusimaa',
  },
  {
    'label': 'Tyrnävä',
    'parent': 'Pohjois-Pohjanmaa',
  },
  {
    'label': 'Ulvila',
    'parent': 'Satakunta',
  },
  {
    'label': 'Urjala',
    'parent': 'Pirkanmaa',
  },
  {
    'label': 'Utajärvi',
    'parent': 'Pohjois-Pohjanmaa',
  },
  {
    'label': 'Utsjoki',
    'parent': 'Lappi',
  },
  {
    'label': 'Uurainen',
    'parent': 'Keski-Suomi',
  },
  {
    'label': 'Uusikaarlepyy',
    'parent': 'Pohjanmaa',
  },
  {
    'label': 'Uusikaupunki',
    'parent': 'Varsinais-Suomi',
  },
  {
    'label': 'Vaasa',
    'parent': 'Pohjanmaa',
  },
  {
    'label': 'Valkeakoski',
    'parent': 'Pirkanmaa',
  },
  {
    'label': 'Valtimo',
    'parent': 'Pohjois-Karjala',
  },
  {
    'label': 'Varkaus',
    'parent': 'Pohjois-Savo',
  },
  {
    'label': 'Vehmaa',
    'parent': 'Varsinais-Suomi',
  },
  {
    'label': 'Vesanto',
    'parent': 'Pohjois-Savo',
  },
  {
    'label': 'Vesilahti',
    'parent': 'Pirkanmaa',
  },
  {
    'label': 'Veteli',
    'parent': 'Keski-Pohjanmaa',
  },
  {
    'label': 'Vieremä',
    'parent': 'Pohjois-Savo',
  },
  {
    'label': 'Vihti',
    'parent': 'Uusimaa',
  },
  {
    'label': 'Viitasaari',
    'parent': 'Keski-Suomi',
  },
  {
    'label': 'Vimpeli',
    'parent': 'Etelä-Pohjanmaa',
  },
  {
    'label': 'Virolahti',
    'parent': 'Kymenlaakso',
  },
  {
    'label': 'Virrat',
    'parent': 'Pirkanmaa',
  },
  {
    'label': 'Vårdö',
    'parent': 'Ahvenanmaa',
  },
  {
    'label': 'Vöyri',
    'parent': 'Pohjanmaa',
  },
  {
    'label': 'Ylitornio',
    'parent': 'Lappi',
  },
  {
    'label': 'Ylivieska',
    'parent': 'Pohjois-Pohjanmaa',
  },
  {
    'label': 'Ylöjärvi',
    'parent': 'Pirkanmaa',
  },
  {
    'label': 'Ypäjä',
    'parent': 'Kanta-Häme',
  },
  {
    'label': 'Ähtäri',
    'parent': 'Etelä-Pohjanmaa',
  },
  {
    'label': 'Äänekoski',
    'parent': 'Keski-Suomi',
  },
  {
    'label': 'Ahvenanmaa',
    'parent': null,
  },
  {
    'label': 'Etelä-Karjala',
    'parent': null,
  },
  {
    'label': 'Etelä-Pohjanmaa',
    'parent': null,
  },
  {
    'label': 'Etelä-Savo',
    'parent': null,
  },
  {
    'label': 'Kainuu',
    'parent': null,
  },
  {
    'label': 'Kanta-Häme',
    'parent': null,
  },
  {
    'label': 'Keski-Pohjanmaa',
    'parent': null,
  },
  {
    'label': 'Keski-Suomi',
    'parent': null,
  },
  {
    'label': 'Kymenlaakso',
    'parent': null,
  },
  {
    'label': 'Lappi',
    'parent': null,
  },
  {
    'label': 'Pirkanmaa',
    'parent': null,
  },
  {
    'label': 'Pohjanmaa',
    'parent': null,
  },
  {
    'label': 'Pohjois-Karjala',
    'parent': null,
  },
  {
    'label': 'Pohjois-Pohjanmaa',
    'parent': null,
  },
  {
    'label': 'Pohjois-Savo',
    'parent': null,
  },
  {
    'label': 'Päijät-Häme',
    'parent': null,
  },
  {
    'label': 'Satakunta',
    'parent': null,
  },
  {
    'label': 'Uusimaa',
    'parent': null,
  },
  {
    'label': 'Varsinais-Suomi',
    'parent': null,
  },
]
